import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment as _env } from '../../src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class RestfulService {
    constructor(protected httpClient: HttpClient, public router: Router) {}

    private getApiUrl() {
        return _env.API_URL;
    }

    public makeLoading(isLoading: boolean) {
        if (isLoading) {
            // document
            //     .getElementsByTagName('body')[0]
            //     .insertAdjacentHTML(
            //         'beforeend',
            //         "<div id='loading-mark'><div class='lds-ring'><div></div><div></div><div></div><div></div></div></div>"
            //     );
        }
    }

    public getHeaders(apiToken = '') {
        const option = {
            headers: new HttpHeaders({
                // Authorization: 'Bearer ' + apiToken,
                Accept: 'application/json',
                // 'Cache-Control': 'no-cache, no-store, must-revalidate',
                // Pragma: 'no-cache',
                'Frontend-Request': 'true',
            }),
        };
        return option;
    }

    private getError(err: any) {
        //   if (err.status === 401) {
        //   }
        if (err.status === 404) {
            // 404画面の表示
            this.router.navigate(['/not-found']);
        }
        return throwError(() => err);
    }

    protected doGet(path: string, apiToken = '', isLoading = true): Observable<any> {
        this.makeLoading(isLoading);
        const options = this.getHeaders(apiToken);
        return this.httpClient
            .get(`${this.getApiUrl()}/${path}`, options)
            .pipe(catchError((err) => this.getError(err)));
    }

    protected doPost(path: string, data?: any, apiToken = '', isLoading = true): Observable<any> {
        this.makeLoading(isLoading);
        const options = this.getHeaders(apiToken);
        return this.httpClient
            .post(
                `${this.getApiUrl()}/${path}${isLoading ? '' : '?no-show-loading'}`,
                data,
                options
            )
            .pipe(catchError((err) => this.getError(err)));
    }

    protected doPut(path: string, data?: any, apiToken = '', isLoading = true): Observable<any> {
        this.makeLoading(isLoading);
        const options = this.getHeaders(apiToken);
        return this.httpClient
            .put(`${this.getApiUrl()}/${path}`, data, options)
            .pipe(catchError((err) => this.getError(err)));
    }

    protected doDownload(path: string, apiToken = '', isLoading = true): Observable<any> {
        this.makeLoading(isLoading);
        const options: any = this.getHeaders(apiToken);
        options.responseType = 'blob';
        return this.httpClient
            .get(`${this.getApiUrl()}/${path}`, options)
            .pipe(catchError((err) => this.getError(err)));
    }
}
